import CookieManager from '@/helpers/cookiemanager'
import Utils from '@/utils'

let connections = { 'default': null, 'delayed': null }

export class PullConnection {
  constructor (defaultPullTime) {
    this.defaultPullTime = defaultPullTime
    this.listening = []
    this.listeners = {}
    this.timekUpdateId = null

    const token = CookieManager.getItem('rzAccessToken')
    if (!token) {
      console.log('Token missing to connect')
      return null
    }

    this.timekUpdateId = setInterval(() => {
      this.onTimeUpdate()
    }, 1000 * this.defaultPullTime)
  }

  onTimeUpdate () {
    Object.keys(this.listeners).forEach((key) => {
      const listener = this.listeners[key]
      listener.fn(...listener.params).then((resp) => {
        Object.keys(listener.callbacks).forEach((cbID) => {
          listener.callbacks[cbID](resp)
        })
      })
    })
  }

  listenUpdate (key, updateFn, dataFn, dataParams) {
    if (!this.listeners[key]) {
      this.listeners[key] = {
        fn: dataFn,
        params: dataParams,
        callbacks: {}
      }
    }

    const id = Utils.uniqueId()
    this.listeners[key].callbacks[id] = updateFn
    this.connectMatch(key)

    return id
  }

  connectMatch (key) {
    console.log(`Listening ${key}, pull every ${this.defaultPullTime}s`)
    this.listening.push(key)
  }

  stopUpdate (key, id) {
    console.log('Remove Pull', id)
    if (this.listeners[key] && this.listeners[key].callbacks[id]) {
      delete this.listeners[key].callbacks[id]
      if (Object.keys(this.listeners[key].callbacks).length === 0) {
        delete this.listeners[key]
      }
    }
  }
}

export const Pull = {
  instance (delayedUpdate = false, freqSeconds = null) {
    let seconds = freqSeconds || 10
    let key = 'default'

    if (freqSeconds) {
      key = `timed_${freqSeconds}`
    } else if (delayedUpdate) {
      key = 'delayed'
      seconds = 2 * 60
    }

    if (!connections[key]) {
      connections[key] = null
    }

    if (connections[key] == null) {
      connections[key] = new PullConnection(seconds)
    }

    return connections[key]
  }
}
